var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkLineLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3589 25.0809H17.6289V22.8809H30.3589V25.0809Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5491 16.9998H25.7891V14.7998H31.5491C36.6266 14.7998 40.7491 18.9223 40.7491 23.9998C40.7491 29.0773 36.6266 33.1998 31.5491 33.1998H25.7891V30.9998H31.5491C35.4115 30.9998 38.5491 27.8623 38.5491 23.9998C38.5491 20.1373 35.4115 16.9998 31.5491 16.9998Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21875 23.9998C7.21875 18.9223 11.3412 14.7998 16.4187 14.7998H22.1788V16.9998H16.4187C12.5563 16.9998 9.41875 20.1373 9.41875 23.9998C9.41875 27.8623 12.5563 30.9998 16.4187 30.9998H22.1788V33.1998H16.4187C11.3412 33.1998 7.21875 29.0773 7.21875 23.9998Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkLineLight);
export default __webpack_public_path__ + "static/media/icon_link_line_light.050d9286.svg";
export { ForwardRef as ReactComponent };